import MapleMarketNavGame from '@/components/maple-market/MapleMarketNavGame';
import { Card } from '../ui/card';

export default function PacManRunner() {
  return (
    <div className="h-full w-full bg-gradient-to-br from-slate-950 via-slate-900 to-black p-6 text-slate-100">
      <div className="mx-auto flex h-full max-w-5xl flex-col gap-6">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.35em] text-yellow-400/80">
            MapleOS Easter Egg
          </div>
          <h1 className="mt-2 text-3xl font-bold tracking-tight">Pac-Man Runner</h1>
          <p className="mt-2 max-w-2xl text-sm text-slate-300">
            Waka waka. The Maple Market nav runner is loose on your desktop. It starts moving on its own, and you can
            take over anytime with the arrow keys.
          </p>
        </div>

        <Card className="relative overflow-hidden border-yellow-500/20 bg-black/70 shadow-2xl">
          <div className="border-b border-yellow-500/20 px-4 py-2 text-xs font-medium uppercase tracking-[0.3em] text-yellow-300/70">
            Insert coin
          </div>
          <div className="relative h-28 bg-[radial-gradient(circle_at_top,_rgba(250,204,21,0.12),_transparent_55%),linear-gradient(180deg,rgba(15,23,42,0.96),rgba(2,6,23,1))]">
            <MapleMarketNavGame height={112} />
          </div>
        </Card>

        <div className="grid gap-3 md:grid-cols-3">
          <Card className="border-slate-800 bg-slate-950/70 p-4">
            <div className="text-xs uppercase tracking-[0.28em] text-slate-400">Controls</div>
            <div className="mt-2 text-sm text-slate-200">Use ← and → to jump in and steer Pac-Man.</div>
          </Card>
          <Card className="border-slate-800 bg-slate-950/70 p-4">
            <div className="text-xs uppercase tracking-[0.28em] text-slate-400">Auto mode</div>
            <div className="mt-2 text-sm text-slate-200">If you stop playing, the runner falls back to autoplay after a short idle pause.</div>
          </Card>
          <Card className="border-slate-800 bg-slate-950/70 p-4">
            <div className="text-xs uppercase tracking-[0.28em] text-slate-400">Objective</div>
            <div className="mt-2 text-sm text-slate-200">Catch ghosts from the front and clear the strip without getting clipped from behind.</div>
          </Card>
        </div>
      </div>
    </div>
  );
}
